module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/contest_stats/mlb/survive/homeruns-rbis-1-12044a5b9979b42605d29419a4c8f221.svg";